import Vue from "vue";
import Vuex from "vuex";

// let widthNum = document.documentElement.clientWidth || document.body.clientWidth;

//挂载Vuex
Vue.use(Vuex);
//创建VueX对象
const store = new Vuex.Store({
  state: {
    //存放的键值对就是所要管理的状态
    // isLandscape: false, // 屏幕是否横屏
    // widthNum: widthNum, // 屏幕宽度
    // isHttps: false, // 是否https协议
    // isPC: true, // 是否PC端
    // locale: "zh",
  },
  mutations: {
    // editLandscape(state, isLandscape) {
    //   state.isLandscape = isLandscape;
    // },
    // isHttpsFunc(state, isHttps) {
    //   state.isHttps = isHttps;
    // },
    // isPC(state, isPC) {
    //   state.isPC = isPC;
    // },
    // SET_LOLALE(state, locale) {
    //   state.locale = locale;
    // },
  },
  getters: {
    // isEnLocale: (state) => state.locale === "en",
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js